function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "71.5092711%",
  y2: "8.62486884%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E38E0B",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD934",
  offset: "44.8925217%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFEE9",
  offset: "100%"
})), /*#__PURE__*/React.createElement("circle", {
  id: "path-2",
  cx: 50,
  cy: 50,
  r: 48
}), /*#__PURE__*/React.createElement("filter", {
  x: "-5.2%",
  y: "-5.2%",
  width: "110.4%",
  height: "110.4%",
  filterUnits: "objectBoundingBox",
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1   0 0 0 0 0.811764706   0 0 0 0 0.0784313725  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 2,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.95   0 0 0 0 0.6175   0 0 0 0 0  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("ellipse", {
  id: "path-4",
  cx: 33.5,
  cy: 7,
  rx: 4.5,
  ry: 7
}), /*#__PURE__*/React.createElement("filter", {
  x: "-44.4%",
  y: "-28.6%",
  width: "188.9%",
  height: "157.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-5"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.768627451   0 0 0 0 0.396078431   0 0 0 0 0.00392156863  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 2,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("ellipse", {
  id: "path-6",
  cx: 4.5,
  cy: 7,
  rx: 4.5,
  ry: 7
}), /*#__PURE__*/React.createElement("filter", {
  x: "-44.4%",
  y: "-28.6%",
  width: "188.9%",
  height: "157.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-7"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.768627451   0 0 0 0 0.396078431   0 0 0 0 0.00392156863  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 2,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M52.1488235,91.4488889 C48.2829218,84.3814461 45.35,76.9485575 45.35,69.15 C45.35,61.3514425 48.2829218,53.9185539 52.1488235,46.8511111 C52.6229435,46.0503664 53.2611725,45.65 54.0635294,45.65 C54.5011787,45.65 54.8749984,45.7892579 55.185,46.0677778 C55.4950015,46.3462977 55.65,46.6944424 55.65,47.1122222 C55.65,47.3559271 55.5952947,47.6170356 55.4858824,47.8955556 C52.4223376,54.7889234 49.8905882,61.8736673 49.8905882,69.15 C49.8905882,76.4263327 52.4223376,83.5110766 55.4858824,90.4044444 C55.5952947,90.7177793 55.65,90.9788878 55.65,91.1877778 C55.65,91.6403726 55.4950016,91.9972209 55.185,92.2583333 C54.8749985,92.5194457 54.5011787,92.65 54.0635294,92.65 C53.2611725,92.65 52.6229435,92.2496336 52.1488235,91.4488889 Z",
  id: "path-8"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-19.4%",
  y: "-4.3%",
  width: "138.8%",
  height: "108.5%",
  filterUnits: "objectBoundingBox",
  id: "filter-9"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.441039741   0 0 0 0 0.211583197   0 0 0 0 0  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "smile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "head"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#linearGradient-1)",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)",
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(31.000000, 33.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "righteye"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FD9B0A",
  fillRule: "evenodd",
  xlinkHref: "#path-4"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-5)",
  xlinkHref: "#path-4"
})), /*#__PURE__*/React.createElement("g", {
  id: "lefteye"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FD9B0A",
  fillRule: "evenodd",
  xlinkHref: "#path-6"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-7)",
  xlinkHref: "#path-6"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(50.500000, 69.150000) rotate(-90.000000) translate(-50.500000, -69.150000) "
}, /*#__PURE__*/React.createElement("use", {
  fill: "#BF7608",
  fillRule: "evenodd",
  xlinkHref: "#path-8"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-9)",
  xlinkHref: "#path-8"
})));

var SvgSmile = function SvgSmile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smile.ec0628a5.svg";
export { ForwardRef as ReactComponent };